import Vue from 'vue'
import dataTools from '../tools/data.js'
import fieldsDescription from '../tools/fieldsDescription.json'
import dataDescription from '../tools/dataDescription.json'
import { mapGetters, mapActions } from 'vuex'
import errorMixin from './logHandler.js'
import loadFormsComponents from '../components/Forms/formsComponents.js'
loadFormsComponents()

export default {
  mixins: [errorMixin],

  mounted() {
    this.$root.$on('open-dialog', this.openDialogHandler)
    this.refreshTable()
    if (
      this.formDataCache != null &&
      this.formDataCache[this.getCurrentFormType()] != null
    ) {
      this.inputs = JSON.parse(
        JSON.stringify(this.formDataCache[this.getCurrentFormType()])
      )
    }
    let waterfallEditionField =
      this.editedComponentName[this.getCurrentFormType()]
    // update from waterfall edition
    if (this.waterfallChildDataCache != null && waterfallEditionField != null) {
      const editedItem = JSON.parse(
        JSON.stringify(this.waterfallChildDataCache)
      )
      if (this.isExoInputMultiple(waterfallEditionField)) {
        const selectedItemsLength = this.inputs[waterfallEditionField].length
        let editedItemIndex = -1
        for (let index = 0; index < selectedItemsLength; index++) {
          const editingSelectedItem =
            this.inputs[waterfallEditionField][index] &&
            this.waterfallChildDataCache.id ===
              this.inputs[waterfallEditionField][index].id
          if (editingSelectedItem) {
            editedItemIndex = index
            break
          }
        }
        //item selected in list
        if (editedItemIndex !== -1) {
          this.inputs[waterfallEditionField][editedItemIndex] = editedItem
        }
        //item selected not in list
        else {
          this.inputs[waterfallEditionField].push(editedItem)
        }
      } else if (this.isExoInputMultipleWithoutForm(waterfallEditionField)) {
        this.saveForParentComponent(editedItem)
      } else {
        const editingSelectedItem =
          this.waterfallChildDataCache.id ===
          this.inputs[waterfallEditionField]?.id

        const creatingItem = this.inputs[waterfallEditionField] == null
        if (editingSelectedItem || creatingItem) {
          this.inputs[waterfallEditionField] = editedItem
        }
      }
    }

    // clean the cache
    this.formDataCache[this.getCurrentFormType()] = null
    this.updateFormDataCache(this.formDataCache)
    this.updateWaterfallChildDataCache(null)
    this.editedComponentName[this.getCurrentFormType()] = null
    this.updateEditedComponentName(this.editedComponentName)
  },

  beforeDestroy() {
    if (this.enableFormCache === true) {
      let updatedCache = this.formDataCache
      if (updatedCache == null) {
        updatedCache = {}
      }
      updatedCache[this.getCurrentFormType()] = JSON.parse(
        JSON.stringify(this.inputs)
      )

      this.updateFormDataCache(updatedCache)
    }
    this.$root.$off('open-dialog', this.openDialogHandler)
  },

  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      currentMission: 'currentMission',
      waterfallChildDataCache: 'waterfallChildDataCache',
      formDataCache: 'formDataCache',
      editedComponentName: 'editedComponentName'
    }),

    submitAction() {
      return this.inputs.editing ? 'Save' : 'Create'
    },
    inputNameFeedback() {
      let feedback = true
      if (this.inputNameState !== null && !this.inputNameState) {
        feedback =
          "Please only use the allowed characters : a-z A-Z 0-9 ' ',.-+=/_#@$&:%|()]["
      }
      return feedback
    },
    inputNameState() {
      let valid = null
      if (this.inputs.name !== '') {
        let allowedChars = RegExp(
          '^[a-zA-Z0-9 ,\\.\\-\\+=\\/_@#\\$&:%\\|\\(\\)\\[\\]]+$'
        )
        valid = allowedChars.test(this.inputs.name)
      }
      return valid
    },
    inputsValid() {
      let fieldsState = this.verifyPropertiesList(
        this.getRequiredPropertiesList(this.inputs),
        this.inputs,
        true
      )
      fieldsState =
        fieldsState &&
        this.verifyPropertiesList(
          this.getOptionalPropertiesList(this.inputs),
          this.inputs,
          false
        )
      // if impossible to validate a form : uncomment the code in verifyPropertiesList to understand the problematic field
      return this.inputNameState && fieldsState
    },

    // checks all inputs except name input (used mainly for visualization purposes with Cesium)
    paramsValid() {
      let keys = Object.keys(this.inputs).filter((k) => k !== 'name')
      let params = {}
      keys.forEach((key) => {
        params[key] = this.inputs[key]
      })
      return this.verifyPropertiesList(
        this.getRequiredPropertiesList(params),
        params,
        true
      )
    }
  },

  data() {
    return {
      tableItems: [],

      lastError: '', // debug purpose; analyze with debugger on web browser

      enableFormCache: true, // activate cache to be used when leaving except if saved before

      inputs: {
        displayForm: false,
        id: '',
        editing: false,
        saving: false,
        name: '',
        description: '',
        parametricValues: {},
        parametricReferences: {}
      }
    }
  },

  methods: {
    ...mapActions([
      'updateFormDataCache',
      'updateWaterfallChildDataCache',
      'updateEditedComponentName'
    ]),

    openDialogHandler(type, item) {
      if (type === this.getCurrentFormType()) {
        this.inputs.displayForm = true
        if (item) {
          this.copyLocalFields(item)
          this.fillMissingDefaultValueInInputs()
          this.inputs.id = item.id
          this.inputs.name = item.name
          this.inputs.description = item.description
          this.inputs.editing = true
        }
      }
    },

    getInfos(item) {
      return dataTools.getInfos(item)
    },

    //overwritten in children files
    isExoInputMultiple(item) {
      return false
    },
    //overwritten in children files
    isExoInputMultipleWithoutForm(item) {
      return false
    },

    fillMissingDefaultValueInInputs() {
      for (let field in this.getPropertiesDescription()) {
        if (this.inputs.hasOwnProperty(field)) {
          if (!this.getFieldState(this.inputs, field, true).value) {
            // false or null
            const defaultValue = this.getDefaultValue(field)
            if (
              defaultValue != null &&
              defaultValue !== '' &&
              defaultValue !== []
            ) {
              this.inputs[field] = defaultValue
            }
          }
        }
      }
    },

    verifyPropertiesList(propertiesList, parentObject, required) {
      let fieldsState = true
      let propertiesDesc = this.getPropertiesDescription()
      for (let fieldName of propertiesList) {
        if (propertiesDesc[fieldName] != null) {
          if (propertiesDesc[fieldName].skipInFormValidation !== true) {
            // false or null
            let currentFieldState = this.getFieldState(
              parentObject,
              fieldName,
              required
            ).value
            if (currentFieldState === null && !required) {
              currentFieldState = true
            }
            // if (!currentFieldState) {
            //   console.log('Field in error : ' + fieldName)
            //   console.log(currentFieldState)
            //   console.log(propertiesDesc[fieldName])
            // }
            fieldsState = fieldsState && currentFieldState
          }
        } else {
          fieldsState = false
        }
      }
      return fieldsState
    },

    getLabel(field) {
      let parentDesc = this.getPropertiesDescription()
      if (!parentDesc[field]) {
        return field
      }
      return parentDesc[field].label
    },

    getFormLabel(field) {
      let label = this.getLabel(field)
      if (this.isRequiredField(field, this.inputs)) {
        label = label + ' *'
      }
      return label
    },

    getDefaultUnitLabel(field) {
      let fieldType = this.getFieldType(field)
      if (!fieldType) {
        // Custom Script Field, no default unit
        return ''
      }
      return (
        ' ' + dataTools.getUnitLabel(dataTools.getDefaultGuiUnit(fieldType))
      )
    },

    getFieldType(field) {
      let parentDesc = this.getPropertiesDescription()
      if (!parentDesc[field] || !parentDesc[field].type) {
        return null
      }
      return parentDesc[field] ? parentDesc[field].type : null
    },

    getDefaultValue(field) {
      // warning GUI value (not SI)
      if (this.isReferenceField(field)) {
        return null
      }
      let fieldDesc = this.getPropertiesDescription()[field]
      if (fieldDesc == null) {
        return ''
      }
      return dataTools.convertSi2gui(
        fieldDesc.type,
        dataTools.convertPiToNumber(fieldDesc.defaultValue)
      )
    },

    isReferenceField(field) {
      let fieldDesc = this.getPropertiesDescription()[field]
      if (fieldDesc == null) {
        return false
      }
      let fieldType = fieldDesc.type
      return fieldsDescription[fieldType] != null
    },

    copy(item) {
      this.inputs.displayForm = true
      this.inputs.editing = false
      this.copyLocalFields(item)
      this.fillMissingDefaultValueInInputs()
      this.inputs.id = ''
      this.inputs.name = item.name + ' (copy)'
      this.inputs.description = item.description
    },

    createObjectFromForm() {
      let baseObject = {
        id: this.inputs.id,
        name: this.inputs.name.trim(),
        description: this.inputs.description
      }
      let fieldsList = this.getAllPropertiesList(this.inputs)
      return this.addLocalFieldsFromForm(baseObject, fieldsList)
    },

    addLocalFieldsFromForm(baseObject, fieldsList) {
      return this.addFieldsListToBaseObject(baseObject, fieldsList)
    },

    getAllPropertiesList(instance) {
      return [
        ...new Set(
          this.getRequiredPropertiesList(instance).concat(
            this.getOptionalPropertiesList(instance)
          )
        )
      ]
    },

    getAllPropertiesUnionList() {
      return [
        ...new Set(
          this.getRequiredPropertiesList(null).concat(
            this.getOptionalPropertiesList(null)
          )
        )
      ]
    },

    getStringFields() {
      let fieldsList = this.getAllPropertiesUnionList()
      let stringFieldsList = ['displayedName']
      for (let field of fieldsList) {
        if (this.getPropertiesDescription()[field] == null) {
          console.log(
            'Internal error : ' +
              field +
              ' unknown field description for ' +
              this.getCurrentFormType()
          )
        }
        let fieldType = this.getPropertiesDescription()[field].type
        if (fieldType === 'string' || fieldType === 'enum') {
          stringFieldsList.push(field)
        }
      }
      return stringFieldsList
    },

    getDateFields() {
      let fieldsList = this.getAllPropertiesUnionList()
      let dateFieldsList = []
      for (let field of fieldsList) {
        let fieldType = this.getPropertiesDescription()[field].type
        if (fieldType === 'date' || fieldType === 'datetime') {
          dateFieldsList.push(field)
        }
      }
      return dateFieldsList
    },

    getValueFields() {
      let fieldsList = this.getAllPropertiesUnionList()
      let valueFieldsList = []
      for (let field of fieldsList) {
        let fieldType = this.getPropertiesDescription()[field].type
        if (dataDescription[fieldType]) {
          valueFieldsList.push(field)
        }
      }
      return valueFieldsList
    },

    getReferenceFields() {
      let fieldsList = this.getAllPropertiesUnionList()
      let referenceFieldsList = []
      for (let field of fieldsList) {
        let fieldType = this.getPropertiesDescription()[field].type
        if (fieldsDescription[fieldType] != null) {
          referenceFieldsList.push(field)
        }
      }
      return referenceFieldsList
    },

    getBooleanFields() {
      let fieldsList = this.getAllPropertiesUnionList()
      let booleanFieldsList = []
      for (let field of fieldsList) {
        let fieldType = this.getPropertiesDescription()[field].type
        if (fieldType === 'boolean') {
          booleanFieldsList.push(field)
        }
      }
      return booleanFieldsList
    },

    getCustomFields() {
      return [] // to be redefined when needed
    },

    displayCustomValue(data, field) {
      return '' // to be redefined when needed
    },

    getEnumProperties: function () {
      let propertiesList = this.getPropertiesDescription()
      let enums = {}
      for (let fieldKey in propertiesList) {
        if (propertiesList.hasOwnProperty(fieldKey)) {
          if (propertiesList[fieldKey].type === 'enum') {
            enums[fieldKey] = propertiesList[fieldKey].values.filter(
              (value) => value.hide !== true
            )
          }
        }
      }
      return enums
    },

    clearForm() {
      this.errorAlertDisplayed = false
      this.successAlertDisplayed = false
      this.inputs.id = ''
      this.inputs.name = ''
      this.inputs.description = ''
      this.inputs.editing = false
      this.inputs.parametricValues = {}
      this.inputs.parametricReferences = {}
      this.clearLocalFields()
    },

    // ---------------------------------------------------------------

    submitForm() {
      if (this.inputs.editing) {
        this.onSave()
      } else {
        this.onCreate()
      }
    },

    edit(item, index) {
      if (item != null) {
        this.copy(item)
        this.inputs.id = item.id
        this.inputs.name = item.name
        this.inputs.description = item.description
        this.inputs.editing = true
      }
    },

    getCurrentAPI() {
      return this.getAPI(this.getCurrentFormAPI())
    },

    getAPI(objectAPI) {
      return '/users/' + this.currentUser.id + '/' + objectAPI.toLowerCase()
    },

    onCreate: function (evt) {
      let self = this
      let objectName = this.inputs.name.trim()
      this.inputs.saving = true
      this.$http
        .post(this.getCurrentAPI(), this.createObjectFromForm())
        .then(async function (response) {
          self.inputs.saving = false
          self.inputs.displayForm = false
          let updatedCache = self.formDataCache
          if (updatedCache == null) {
            updatedCache = {}
          }
          updatedCache[self.getCurrentFormType()] = null
          self.enableFormCache = false // no need to save in cache as it saved in DB
          self.updateFormDataCache(updatedCache)
          self.updateWaterfallChildDataCache(response.data)
          self.clearForm()
          self.successAlertMessage = objectName
          await self.refreshTable()
          self.$root.$emit('actualize-table-page', objectName)
          let history = JSON.parse(localStorage.getItem('history') || '[]')
          if (history.length) {
            let historyElement = history.pop()
            self.$router.push({ name: historyElement.routeName })
            localStorage.setItem('history', JSON.stringify(history))
            Vue.nextTick(() => {
              self.$root.$emit('current-mission-updated')
              self.$root.$emit('open-dialog', self.$router.currentRoute.name)
            })
          }
        })
        .catch((e) => {
          self.inputs.saving = false
          self.displayMessage(
            'Error creating ' + objectName + '. ',
            e,
            'notification',
            'error'
          )
        })
    },

    onSave: function (evt) {
      let self = this
      let objectName = this.inputs.name.trim()
      self.$root.$emit('before-clearing-form')
      this.inputs.saving = true
      this.$http
        .put(
          this.getCurrentAPI() + '/' + this.inputs.id,
          this.createObjectFromForm()
        )
        .then(async (response) => {
          self.inputs.saving = false
          self.$root.$emit('base-object-updated')
          this.inputs.displayForm = false
          let updatedCache = this.formDataCache
          if (updatedCache == null) {
            updatedCache = {}
          }
          updatedCache[self.getCurrentFormType()] = null
          self.enableFormCache = false // no need to save in cache as it saved in DB
          self.updateFormDataCache(updatedCache)
          self.updateWaterfallChildDataCache(response.data)
          this.clearForm()
          self.successAlertMessage = objectName
          await self.refreshTable()
          let history = JSON.parse(localStorage.getItem('history') || '[]')
          if (history.length) {
            let historyElement = history.pop()
            self.$router.push({ name: historyElement.routeName })
            localStorage.setItem('history', JSON.stringify(history))
            Vue.nextTick(() => {
              self.$root.$emit('current-mission-updated')
              self.$root.$emit('open-dialog', self.$router.currentRoute.name)
            })
          }
        })
        .catch((e) => {
          self.inputs.saving = false
          self.displayMessage(
            'Error updating ' + objectName + '. ',
            e,
            'notification',
            'error'
          )
        })
    },

    refreshTable: function () {
      let self = this
      if (this.$http != null) {
        return this.$http
          .get(this.getCurrentAPI())
          .then((response) => {
            self.tableItems = response.data
            Object.keys(self.tableItems).map((key) => {
              let value = self.tableItems[key]
              if (value.dirty) {
                self.tableItems[key]._rowVariant = 'danger'
              }
              return self.tableItems[key]
            })
            if (this.refreshReferences) {
              this.refreshReferences()
            }
          })
          .catch((e) => {
            self.displayMessage(
              'Error getting the list. ',
              e,
              'missionTableErrorDisplay',
              'error'
            )
            // TODO MFI proper message for standard HTML status (504 -> server down), 500 contact admin
          })
      }
    },

    removeIfNotUsedAsReference: function (item, index, button) {
      let self = this
      let objectName = item.name
      if (this.inputs.editing) {
        this.clearForm()
      }
      this.$http
        .get(this.getCurrentAPI() + '/' + item.id + '/usedby')
        .then((response) => {
          if (response.data && response.data.length === 0) {
            this.$http
              .delete(this.getCurrentAPI() + '/' + item.id)
              .then(() => {
                self.$root.$emit('base-object-updated')
                self.successAlertDisplayed = true
                self.successAlertMessage = objectName + ' deleted'
                self.refreshTable()
              })
              .catch((e) => {
                self.displayMessage(
                  'Error deleting ' + objectName + '. ',
                  e,
                  'notification',
                  'error'
                )
                self.refreshTable()
              })
          } else {
            this.showModal = true
            this.modalRef.content = new Set(response.data)
            this.modalRef.item = item
            Vue.nextTick(() => {
              this.$root.$emit('bv::show::modal', 'modalRef', button)
            })
          }
        })
        .catch((e) => {
          self.displayMessage(
            'Error deleting ' + objectName + '. ',
            e,
            'notification',
            'error'
          )
          self.refreshTable()
        })
    },

    remove: function (item, index, button) {
      let self = this
      let objectName = item.name
      if (this.inputs.editing) {
        this.clearForm()
      }
      this.$http
        .delete(this.getCurrentAPI() + '/' + item.id)
        .then(() => {
          self.$root.$emit('base-object-updated')

          self.successAlertDisplayed = true
          self.successAlertMessage = objectName + ' deleted'
          self.refreshTable()
        })
        .catch((e) => {
          self.displayMessage(
            'Error deleting ' + objectName + '. ',
            e,
            'notification',
            'error'
          )
          self.refreshTable()
        })
    },

    removeAll: function () {
      let self = this
      if (this.inputs.editing) {
        this.clearForm()
      }
      this.$http
        .delete(this.getCurrentAPI())
        .then(() => {
          self.$root.$emit('base-object-updated')
          self.successAlertDisplayed = true
          self.successAlertMessage = 'All items deleted successfully'
          self.refreshTable()
        })
        .catch((e) => {
          self.displayMessage(
            'Error deleting all items. ',
            e,
            'notification',
            'error'
          )
          self.refreshTable()
        })
    },

    importDefaultData: async function () {
      let self = this
      this.$http.put(this.getCurrentAPI() + '/defaultdata').then(() => {
        self.refreshTable()
      })
      // this.$http.put(this.getCurrentFormTitle()
    },

    // ---------------------- field checks -----------------

    getEnumFieldState(parentObject, fieldName, required) {
      let state = {
        value: true, // do not initialize with null, it means field empty
        message: true
      }
      if (parentObject[fieldName] == null && !required) {
        return state
      }

      let fieldDesc = this.getPropertiesDescription()[fieldName]
      state.value = false
      state.message = 'Please select a valid value'
      if (Array.isArray(parentObject[fieldName])) {
        if (required && parentObject[fieldName].length === 0) {
          state.value = false
          state.message = 'Please select at least one value'
        } else {
          // if multi select (no value set can be a right value)
          state.value = true
          state.message = true
        }
      } else {
        for (let value in fieldDesc.values) {
          if (fieldDesc.values[value].value === parentObject[fieldName]) {
            state.value = true
            state.message = true
          }
        }
      }
      return state
    },

    getFieldValueState(fieldDesc, fieldType, value) {
      let dataDesc = dataDescription[fieldType]
      let state = {
        value: null,
        message: true
      }
      // temporary fix for enums
      if (fieldType === 'enum') {
        return { value: true, message: true }
      }
      if (value === '' || value == null || dataDesc == null) {
        return state
      }
      if (dataDesc.guiUnit === '24h00') {
        let hoursVal
        if (dataTools.isNumber(value)) {
          hoursVal = value
        } else {
          const parts = value.split('h')
          const hours = parts[0]
          if (parts.length > 2) {
            state.value = false
            state.message =
              'Invalid format. Example of accepted values: 10, 10h, 3h30, 3.5'
            return state
          }
          if (!dataTools.isNumber(hours)) {
            state.value = false
            state.message =
              "Number expected for hours, found '" +
              hours +
              "'. e.g. 10, 10h, 3h30, 3.5"
            return state
          }
          if (parts.length === 2) {
            let mn = parts[1]
            if (mn.trim() !== '') {
              if (!dataTools.isNumber(mn)) {
                state.value = false
                state.message =
                  "Number expected for minutes, found '" +
                  mn +
                  "'. e.g. 10, 10h, 3h30, 3.5"
                return state
              }
              let minutes = parseFloat(mn)
              if (minutes >= 60) {
                state.value = false
                state.message = 'The number of minutes must be below 60.'
                return state
              }
              if (minutes < 0) {
                state.value = false
                state.message = 'The number of minutes must be higher than 0.'
                return state
              }
              if (parseFloat(minutes) !== parseInt(minutes, 10)) {
                state.value = false
                state.message = 'The number of minutes must be a whole number'
                return state
              }
            }
          }
          hoursVal = parseFloat(hours)
        }
        let maxHours
        let minHours
        if (fieldDesc.maxExclusive) {
          maxHours = fieldDesc.maxExclusive / 3600
        } else if (fieldDesc.maxInclusive) {
          maxHours = fieldDesc.maxInclusive / 3600
        }
        if (
          hoursVal >= fieldDesc.maxEnclusive / 3600 ||
          hoursVal > fieldDesc.maxInclusive / 3600
        ) {
          state.value = false
          state.message =
            'The value must be below ' + maxHours + 'h. e.g. 10, 10h, 3h30, 3.5'
          return state
        }
        if (fieldDesc.minExclusive) {
          minHours = fieldDesc.minExclusive / 3600
        } else if (fieldDesc.minInclusive) {
          minHours = fieldDesc.minInclusive / 3600
        }
        if (
          hoursVal < fieldDesc.minInclusive / 3600 ||
          hoursVal <= fieldDesc.minExclusive / 3600
        ) {
          state.value = false
          state.message =
            'The value must be higher than ' +
            minHours +
            'h. e.g. 10, 10h, 3h30, 3.5'
          return state
        }
        return { value: true, message: true }
      }
      if (
        dataDesc.type === 'double' ||
        dataDesc.type === 'int' ||
        dataDesc.type === 'integer'
      ) {
        if (!dataTools.isNumber(value)) {
          state.value = false
          state.message = "Number expected instead of '" + value + "'"
          return state
        }
        if (dataDesc.type === 'int' || dataDesc.type === 'integer') {
          if (parseFloat(value) !== parseInt(value, 10)) {
            state.value = false
            state.message = "Integer expected instead of '" + value + "'"
            return state
          }
        }
        value = parseFloat(value)
        let minExclusive = dataTools.convertPiToNumber(fieldDesc.minExclusive)
        if (dataTools.isNumber(minExclusive)) {
          let bound = dataTools.convertSi2gui(fieldType, minExclusive)
          if (value <= bound) {
            state.value = false
            state.message = 'Input must be > ' + bound
            return state
          }
        }
        let minInclusive = dataTools.convertPiToNumber(fieldDesc.minInclusive)
        if (dataTools.isNumber(minInclusive)) {
          let bound = dataTools.convertSi2gui(fieldType, minInclusive)
          if (value < bound) {
            state.value = false
            state.message = 'Input must be >= ' + bound
            return state
          }
        }
        let maxExclusive = dataTools.convertPiToNumber(fieldDesc.maxExclusive)
        if (dataTools.isNumber(maxExclusive)) {
          let bound = dataTools.convertSi2gui(fieldType, maxExclusive)
          if (value >= bound) {
            state.value = false
            state.message = 'Input must be < ' + bound
            return state
          }
        }
        let maxInclusive = dataTools.convertPiToNumber(fieldDesc.maxInclusive)
        if (dataTools.isNumber(maxInclusive)) {
          let bound = dataTools.convertSi2gui(fieldType, maxInclusive)
          if (value > bound) {
            state.value = false
            state.message = 'Input must be <= ' + bound
            return state
          }
        }
        let excludeValues = dataTools.convertPiToNumber(fieldDesc.excludeValues)
        if (Array.isArray(excludeValues) && excludeValues.length > 0) {
          for (let excludeValue of excludeValues) {
            let excludeValueGUI = dataTools.convertSi2gui(
              fieldType,
              excludeValue
            )
            if (value === excludeValueGUI) {
              state.value = false
              state.message = 'Input can not be equal to ' + excludeValueGUI
              return state
            }
          }
        }
      }
      if (dataDesc.type === 'string' && fieldDesc.rule != null) {
        const rule = new RegExp(fieldDesc.rule)
        const match = value.match(rule)
        if (!match || value !== match[0]) {
          state.value = false
          state.message =
            fieldDesc.errorMessage != null
              ? fieldDesc.errorMessage
              : 'Invalid input'
          return state
        }
      }
      state.value = true
      return state
    },

    updateState(state, newState) {
      if (state.value !== false) {
        state.message = newState.message
        if (newState.value === false) {
          state.value = false
        } else if (state.value != null) {
          // true
          state.value = newState.value // can be null : disable validate button without error on field
        }
      } // else already an error
    },

    // ---------------------- end field checks -----------------

    isAnalyticalMission() {
      return (
        this.currentMission != null &&
        this.currentMission.typeName === 'ParametricStudyRequest'
      )
    },

    isNumericalMission() {
      return (
        this.currentMission != null &&
        this.currentMission.typeName === 'SimulationRequest'
      )
    },

    isConstellationMission() {
      return (
        this.currentMission != null &&
        (this.currentMission.typeName ===
          'ConstellationPerformanceAnalysisRequest' ||
          this.currentMission.typeName === 'ConstellationOptimizationRequest' ||
          this.currentMission.typeName === 'ConstellationSimulationRequest' ||
          this.currentMission.typeName === 'ConstellationGenerationRequest')
      )
    },

    isDeploymentMission() {
      return (
        this.currentMission != null &&
        this.currentMission.typeName === 'DeploymentRequest'
      )
    },

    isAdvancedConfiguration(name) {
      let advancedConfiguration = false
      const description = this.getPropertiesDescription()[name]
      if (description != null) {
        advancedConfiguration =
          this.getPropertiesDescription()[name].advancedConfiguration
      }
      return advancedConfiguration === true
    },

    isConfigurationEnabledByUser(name) {
      let key = this.getCurrentFormType() + '/' + name
      let enableAdvancedConfiguration =
        this.currentUser?.userSettings?.advancedConfigurations?.[key]
      if (enableAdvancedConfiguration === false) {
        return false
      }
      return true
    },

    isOptionDisabled(name) {
      let disabled = false
      if (this.isAdvancedConfiguration(name)) {
        disabled = !this.isConfigurationEnabledByUser(name)
      }
      return disabled
    },

    // warning : for forms, call it on inputs
    isRequiredOrOptional(name, parentObject) {
      if (this.isOptionDisabled(name)) {
        return false
      }
      let isRequired = this.isRequiredField(name, parentObject)
      return (
        isRequired ||
        this.getOptionalPropertiesList(parentObject).includes(name)
      )
    },

    isRequiredField(name, parentObject) {
      return this.getRequiredPropertiesList(parentObject).includes(name)
    },

    getCurrentFormTitle() {
      return this.getCurrentFormDescription().label
    },

    getCurrentFormDescription() {
      return fieldsDescription[this.getCurrentFormType()]
    },

    getPropertiesDescription() {
      return this.getCurrentFormDescription().properties
    },

    getRequiredPropertiesList(instance) {
      if (this.getCurrentFormDescription().required == null) {
        return []
      }
      return this.getCurrentFormDescription().required
    },

    getOptionalPropertiesList(instance) {
      if (this.getCurrentFormDescription().optional == null) {
        return []
      }
      return this.getCurrentFormDescription().optional
    },

    getCurrentFormAPI() {
      return this.getCurrentFormType() + 's'
    }
  }
}
